import * as React from "react";
import styled from "styled-components";

import { Batch8NewFooter } from "./batch8NewFooter/Batch8NewFooter";

interface IPropTypes {
  className?: string;
  noTopBorder?: boolean;
  noTopMargin?: boolean;
  childFirst?: boolean;
  children?: React.ReactNode;
  hideReferral?: boolean;
  showRetailerFooterForNewFooterXP?: boolean;
  isNewsroomPage?: boolean;
}

export const Footer: React.FC<
  IPropTypes & {
    ref?: React.Ref<HTMLDivElement>;
  }
> = (props) => {
  return (
    <FooterWrapper>
      <Batch8NewFooter {...props} />
    </FooterWrapper>
  );
};

const FooterWrapper = styled.div`
  width: 100%;
`;
